// Carousel cards
$('.js-cardWrap').owlCarousel({
    loop: false,
    margin: 12,
    lazyLoad: true,
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 3
        },
        1024: {
            items: 3,
            margin: 24,
        },
        1440: {
            margin: 36,
        }
    },
    onInitialized: addDotButtonText,
    onResized: addDotButtonText
});

$('.js-gallery').owlCarousel({
    loop: true,
    lazyLoad: true,
    items: 1,
    dots: false,
    nav: true,
    autoHeight: true
});

$('.js-cont-slider').owlCarousel({
    loop: true,
    lazyLoad: true,
    items: 1,
    dots: false,
    nav: true,
    autoHeight: true
});

function addDotButtonText() {
    $('.owl-dot').each(function() {
        // remove old text nodes
        $(this).find('.offscreen').remove();

        // grab its (zero-based) order in the series
        let idx = $(this).index() + 1;

        // append a span to the button containing descriptive text
        $(this).attr('aria-label', 'Go to slide ' + idx);
    });
}